import { Route } from '@angular/router';
import { CallbackComponent } from '@thiememeulenhoff/ng-security';

import { adminAccessGuard } from '../features/admin/_guards/admin-access.guard';

const routes: Array<Route> = [
  {
    path: 'forbidden',
    loadComponent: () =>
      import('../features/admin/_ui/admin-forbidden/admin-forbidden.component').then(
        (module) => module.AdminForbiddenComponent,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('../features/admin/_ui/admin-layout/admin-layout.component').then(
        (m) => m.AdminLayoutComponent,
      ),
    canActivate: [adminAccessGuard],
    children: [
      {
        path: 'user',
        loadChildren: () =>
          import('../features/admin/admin-user/admin-user.routes').then(
            (module) => module.adminUserRoutes,
          ),
      },
      {
        path: 'oauth/callback',
        component: CallbackComponent,
      },
      {
        path: '**',
        loadComponent: () =>
          import('../features/admin/admin-user/admin-user.component').then(
            (module) => module.AdminUserComponent,
          ),
      },
    ],
  },
];

export default routes;
